<template>
  <v-card>
    <v-tabs v-model="tab">
      <v-tab>Negociações</v-tab>
      <v-tab>Histórico de alterações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card
          flat
        >
          <v-card-text>
            <px-resposta-cotacao-frete-negociacao :resposta="resposta"
                                                  :cotacao="cotacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
        >
          <v-card-text>
            <px-resposta-cotacao-frete-historico :resposta="resposta"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>

</template>

<script>
import RespostaCotacaoFreteHistorico from './RespostaCotacaoFreteHistorico.vue';
import RespostaCotacaoFreteNegociacao from './negociacao/RespostaCotacaoFreteNegociacao.vue';

export default {
  props: {
    resposta: Object,
    cotacao: Object,
  },
  data() {
    return {
      tab: 0,
    };
  },
  components: {
    pxRespostaCotacaoFreteHistorico: RespostaCotacaoFreteHistorico,
    pxRespostaCotacaoFreteNegociacao: RespostaCotacaoFreteNegociacao,
  },
};
</script>
